import React from 'react'
import type { Icon } from 'shared/utils'

const Sesame = (props: Icon) => {
    const { color = 'black', size = 24, className = 'sesame' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <path
                d="M4.88 15.08c.76 0 1.4.64 1.4 1.4 0 .76-.64 1.4-1.4 1.4-.76 0-1.4-.64-1.4-1.4 0-.76.64-1.4 1.4-1.4zm-.52-6.76c1.32 0 2.36 1.08 2.36 2.36a2.34 2.34 0 0 1-2.36 2.36A2.34 2.34 0 0 1 2 10.68a2.34 2.34 0 0 1 2.36-2.36zm4.68 1.04c-.76 0-1.4-.64-1.4-1.4 0-.76.64-1.4 1.4-1.4.76 0 1.4.64 1.4 1.4 0 .76-.64 1.4-1.4 1.4zm7.24 7.6c1.2 0 2.24 1 2.24 2.24 0 1.24-1 2.24-2.24 2.24-1.24 0-2.24-1-2.24-2.24 0-1.24 1-2.24 2.24-2.24zM19 8.56c1.48-.04 2.68 1.2 2.68 2.68A2.68 2.68 0 1 1 19 8.56zm-6.48 4.16c.76 0 1.4.6 1.4 1.4 0 .76-.64 1.4-1.4 1.4-.76 0-1.4-.64-1.4-1.4 0-.76.64-1.4 1.4-1.4zM9.2 16.64c.76 0 1.4.6 1.4 1.4 0 .76-.64 1.4-1.4 1.4-.76 0-1.4-.64-1.4-1.4 0-.76.64-1.4 1.4-1.4zm4.48-8.76c-1.24 0-2.24-1-2.24-2.24 0-1.24 1-2.24 2.24-2.24 1.24 0 2.24 1 2.24 2.24 0 1.24-1 2.24-2.24 2.24z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Sesame }
